import { LBtn } from "@components";
import { useModal } from "@services/ModalContext";

export const StaffModalFooter = ({ loading, items }: StaffModalFooterProps): JSX.Element => {
    const { closeModal, onConfirm } = useModal();

    return (
        <div className="is-flex is-flex-direction-row is-justify-content-space-between">
            <LBtn variation="unstyled" onClick={closeModal} isBold>
                Cancel
            </LBtn>
            <LBtn type="submit" form="clinicalStaff" isBold loading={loading} onClick={onConfirm}>
                {`Invite ${items} ${items > 1 ? "users" : "user"}`}
            </LBtn>
        </div>
    );
};

interface StaffModalFooterProps {
    loading?: boolean;
    items: number;
    confirmDisabled?: boolean;
}
